<template>
<!--  table-mouse 用来监听绑定宽度的 -->
  <!-- <div class="details-table-row min-width"> -->
  <div class="details-table-row">
    <slot></slot>
  </div>
</template>

<script>
  export default {
    name: "table-header-col",
  }
</script>

<style scoped>
  .details-table-row {
    /*display: table-cell;*/
    /*table-layout: fixed;*/
    border-right: 1px solid #E5E5E5;
    border-bottom: 1px solid #E5E5E5;
    font-size:14px;
    color: rgba(51,51,51,1);
    /*flex: 1;*/
    vertical-align: middle;
    position: relative;
  }
  .min-width {
    min-width: 90px;
  }
</style>
